import { useEffect } from "react";

export function PlaceholderPage({ title }: { readonly title: string }) {
  useEffect(() => { document.title = `${title} | PedEmUP`; }, [title]);
  return <section className="placeholder-page"><p className="eyebrow">PedEmUP</p><h1>{title}</h1><p>Bu bölüm doğrulanmış kaynak içerikle yeni uygulama çalışma alanına aktarılıyor.</p></section>;
}
